import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Nav from "@/components/Nav";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ProposalsList, ProposalDetail } from "@/pages/Proposals";
import Learn from "@/pages/Learn";
import Companies from "@/pages/Companies";
import { RoomsList, RoomView } from "@/pages/Rooms";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Leaderboard from "@/pages/Leaderboard";
import Messages from "@/pages/Messages";
import Updates from "@/pages/Updates";
import Friends from "@/pages/Friends";
import { CompaniesWall, CompanyPage } from "@/pages/CompanyWall";
import CompanyPortal from "@/pages/CompanyPortal";
import AdminCodes from "@/pages/AdminCodes";
import AdminUsers from "@/pages/AdminUsers";
import AdminBugs from "@/pages/AdminBugs";
import AdminReports from "@/pages/AdminReports";
import Profile from "@/pages/Profile";
import VerifyReport from "@/pages/VerifyReport";
import { BountySuccess } from "@/pages/BountySuccess";
import WelcomeOnboarding from "@/components/WelcomeOnboarding";
import "@/App.css";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-background text-foreground">
            <Nav />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/proposals" element={<ProposalsList />} />
              <Route path="/proposals/:id" element={<ProposalDetail />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/companies/portal" element={<CompanyPortal />} />
              <Route path="/admin/codes" element={<AdminCodes />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/bugs" element={<AdminBugs />} />
              <Route path="/admin/reports" element={<AdminReports />} />
              <Route path="/u/:userId" element={<Profile />} />
              <Route path="/verify" element={<VerifyReport />} />
              <Route path="/bounty/success" element={<BountySuccess />} />
              <Route path="/rooms" element={<RoomsList />} />
              <Route path="/rooms/:slug" element={<RoomView />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/updates" element={<Updates />} />
              <Route path="/friends" element={<Friends />} />
              <Route path="/companies-wall" element={<CompaniesWall />} />
              <Route path="/companies-wall/:company" element={<CompanyPage />} />
            </Routes>
            <WelcomeOnboarding />
            <Toaster theme="dark" position="top-right" />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
